import { Theme } from "@emotion/react";

export const theme = {
  colors: {
    white: "#FFFFFF",
    black: "#000000",
    black100: "#0A080B",
    surfaceOverlay: "#0A080B80",
    redBlack: "#B02828",
    green: "#298548",
    lightOrange: "#F4D793",
    redHover: "#8d1b1b",
    lightText: "#F4D793",
    darkGreen: "#F6DC40",
    red: "#ff2f2f",
    redA: "#ca2a09",
    gray: {
      0: "#f0f0f0",
      10: "#c8c8ca",
      20: "#f7f7f7",
      100: "#AFAFB5",
      150: "#E0E0E0",
      200: "#95959D",
      250: "#b8b8b8",
      300: "#636369",
      350: "#e2e2e2",
      400: "#c3c3c3",
    },
    gradient: {
      1: "linear-gradient(180deg, #FFDB24 0%, #E9A811 51.92%, #FBFF00 100%)",
      2: " linear-gradient(180deg, #FAFAFA 0%, #F4E7E8 100%)",
      3: " linear-gradient(180deg, #F31E27 0%, #298548 100%)",
      4: "linear-gradient(180deg, #fff, #f0f6ff)",
      5: "rgba(107, 123, 168, 0.25)",
      6: "linear-gradient(180deg, #FAFAFA 0%, #E7F4E8 100%);",
    },
    text: {
      buttonActive: "#333333",
      black: "#1C1C1E",
      green: "#10AC02",
      darkGreen: "#768D78",
      white_light: "#201a1a",
      orange: "#ee6f4f",
      back: "#ecd2d3",
    },
    bank: {
      1: "#044FA2",
      2: "#238952",
      3: "#E1AA31",
      4: "#245D7A",
      5: "#2F2851",
      6: "#6B8DBD",
      7: "#C7B141",
      8: "#24AEB9",
      9: "#2C5781",
      10: "#DF621C",
    },
    brown: {
      10: "#C1B4B4",
      20: "#83696a",
    },
  },
  fontSize: {
    13: "13px",
    14: "14px",
    15: "15px",
    16: "16px",
    18: "18px",
    20: "20px",
    24: "24px",
    32: "32px",
    36: "36px",
    40: "40px",
    48: "48px",
    64: "64px",
    96: "96px",
  },
  borders: {
    primary: "#FFDB24",
    secondary: "#3b2e09",
    tertiary: "#7e5801",
  },
  typography: {
    pageTitle: {
      fontSize: "22px",
      fontWeight: 700,
      lineHeight: "28px",
      letterSpacing: "0.2px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "24px",
      letterSpacing: "0.2px",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "22px",
    },
    bodyLg: {
      fontSize: "15px",
      fontWeight: 500,
      lineHeight: "22px",
    },
    body: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    bodySm: {
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "18px",
    },
    label: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: "0.4px",
      textTransform: "uppercase" as const,
    },
    caption: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    tableHeader: {
      fontSize: "13px",
      fontWeight: 600,
      lineHeight: "18px",
      letterSpacing: "0.3px",
    },
    tableCell: {
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "18px",
    },
    button: {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "20px",
      letterSpacing: "0.4px",
    },
  },
  palette: {
    text: {
      primary: "#F4D793",
      secondary: "#AFAFB5",
      muted: "#95959D",
      accent: "#FFDB24",
      inverted: "#000000",
      success: "#10AC02",
      danger: "#FF2F2F",
      info: "#4AA8FF",
    },
    surface: {
      page: "#0A080B",
      card: "rgba(255, 255, 255, 0.02)",
      elevated: "rgba(255, 255, 255, 0.04)",
      overlay: "rgba(10, 8, 11, 0.6)",
    },
    border: {
      subtle: "rgba(244, 215, 147, 0.12)",
      default: "rgba(255, 219, 36, 0.35)",
      strong: "#FFDB24",
    },
    accent: {
      tint: "rgba(255, 219, 36, 0.12)",
      softTint: "rgba(255, 219, 36, 0.06)",
      glow: "rgba(233, 168, 17, 0.35)",
    },
  },
} as Theme;
